// extracted by mini-css-extract-plugin
module.exports = {"box":"FJIntroItem_box__p7Kk1","selected":"FJIntroItem_selected__JtaJG","image":"FJIntroItem_image__1KL-4","video":"FJIntroItem_video__3woTA"};